"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.twMerge = void 0;
exports.createTwMerge = createTwMerge;
const tailwind_merge_1 = require("tailwind-merge");
/*
 * Tokens from styles.css on tailwind-merge's closed-list scales, so they
 * conflict-resolve like built-ins; colors need no listing. A new token on
 * one of these scales must be added here in the same change.
 */
const themeExtension = {
    radius: ["card", "control", "chip", "pill"],
    shadow: ["surface", "card", "card-lifted", "sticky"],
    "drop-shadow": ["hard"],
    ease: ["spring", "exit"],
    spacing: ["gutter", "nav", "fade-edge", "scroll-tail"],
    text: ["title", "display"],
};
const classGroupExtension = {
    duration: [{ duration: ["fast", "base", "slow"] }],
};
function createTwMerge(prefix) {
    return (0, tailwind_merge_1.extendTailwindMerge)({
        prefix,
        extend: {
            theme: themeExtension,
            classGroups: classGroupExtension,
        },
    });
}
exports.twMerge = createTwMerge("ko");
